export const tr = {
    'cannot-be-empty': 'Alan doldurulmalıdır',
    'default-error': 'Bilinmeyen hata: {errorCode}',
    'size-cannot-be-more-than-max': 'Toplam 5 ek parametre eklenebilir',
    'this-tracking-system-domain-not-supported': 'İzleme sisteminin mevcut alan adı desteklenmiyor',
    'this-tracking-system-domain-only-supports-https':
        'İzleme sisteminin mevcut alan adı sadece https protokolünü desteklemektedir',
    'tracker-url-does-not-match-selected-tracker-system':
        'İzleme bağlantısının alan adı seçilen izleme sistemine uygun değil',
    'tracking-url-doesnt-contain-macros':
        'İzleme bağlantısı, cihazları izlemek için makro içermelidir (logid, google_aid, ios_ifa)'
};
